import TextHeader from 'components/CustomText/TextHeader';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const SLeftSection = styled.div`
`;

// const useStyles = makeStyles((theme) => ({
//     formControl: {
//         // margin: theme.spacing(1),
//         minWidth: 120,
//     },
// }));

const SRightSection = styled.div``;

const SubHeader = () => {
    // const dispatch = useDispatch();

    // const handleChange = (event) => {
    //     dispatch(
    //         setGlobal({
    //             dashboardDate: event.target.value,
    //         }),
    //     );
    // };

    return (
        <SLayout>
            <SLeftSection><TextHeader>Dashboard</TextHeader></SLeftSection>
            <SRightSection>
                {/* <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel>Date</InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={dashboardDate}
                        onChange={handleChange}
                        label="Date"
                    >
                        <MenuItem value="today">
                            <em>Today</em>
                        </MenuItem>
                        <MenuItem value={'week'}>Week</MenuItem>
                        <MenuItem value={'month'}>Month</MenuItem>
                    </Select>
                </FormControl> */}
            </SRightSection>
        </SLayout>
    );
};

export default SubHeader;
